import axios from "axios";
import { BOARDS_API_BASE_URL } from "../constants/configuration";

// Axios instance for the boards service (smarthatch-boards-service). The
// auth cookie (`urltoken`) is set by the login-system and shared across ports
// on localhost in dev / sibling subdomains in prod. The boards service does
// not enforce CSRF in Phase 1 — no header echoing needed.
const boardsAxios = axios.create({
  baseURL: BOARDS_API_BASE_URL,
  withCredentials: true,
});

boardsAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      localStorage.clear();
      if (window.location.pathname !== "/") {
        window.location.replace("/");
      }
    }
    return Promise.reject(error);
  },
);

export default boardsAxios;
